import { createContext } from 'react';

import { DirectorySchemaData } from 'api/types/data/directory/directory';
import { OrderOperationType } from 'api/types/entity';

import {
  CurrenciesSchema,
  FinancialInstrumentsSchema,
  SenderOrRecipientDetailsSchema,
} from '../../types';

export interface OrderContextProps {
  schemas: DirectorySchemaData[] | undefined;
  orderType: OrderOperationType;
  directories: {
    financialInstruments?: FinancialInstrumentsSchema;
    currencies?: CurrenciesSchema;
    senderOrRecipientDetails?: SenderOrRecipientDetailsSchema;
  };
  disabledDates: Date[];
  minEndDate?: Date;
  brokerTimezoneOffset: number;
}

export const OrderContext = createContext<OrderContextProps | null>(null);
